import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import * as styles from './TgbTemplate.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var TgbTemplate = /*#__PURE__*/function (_React$PureComponent) {
  function TgbTemplate() {
    _classCallCheck(this, TgbTemplate);
    return _callSuper(this, TgbTemplate, arguments);
  }
  _inherits(TgbTemplate, _React$PureComponent);
  return _createClass(TgbTemplate, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        image = _this$props.image,
        title = _this$props.title,
        description = _this$props.description,
        phone = _this$props.phone,
        footnote = _this$props.footnote,
        url = _this$props.url;
      return /*#__PURE__*/_jsxs("a", {
        href: url,
        target: "_blank",
        rel: "noreferrer noopener nofollow",
        className: styles['container'],
        children: [/*#__PURE__*/_jsx("div", {
          className: styles['image'],
          children: /*#__PURE__*/_jsx("img", {
            src: image,
            alt: title
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles['aside'],
          children: [/*#__PURE__*/_jsx("h4", {
            className: styles['title'],
            children: title
          }), /*#__PURE__*/_jsx("p", {
            className: styles['text'],
            children: description
          }), phone && /*#__PURE__*/_jsx("div", {
            className: styles['phone'],
            children: phone
          })]
        }), footnote && /*#__PURE__*/_jsx("div", {
          className: styles['note'],
          children: footnote
        })]
      });
    }
  }]);
}(React.PureComponent);